import PropTypes from 'prop-types'

import StatsCard from '../StatsCard/Index'

const StatsCounterCard = ({ title, subtitle, color, icon, fetching, value }) => {
  return (
    <StatsCard
      fetching={fetching}
      title={title}
      subtitle={subtitle}
      color={color}
      icon={icon}
      value={value}
    />
  )
}

StatsCounterCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  fetching: PropTypes.bool,
  value: PropTypes.number,
}

export default StatsCounterCard
